const getRandomList = (originData, exludeData, randomLength) => {
  /** 根据游戏列表随机返回三个游戏，如果是游戏页面，需要从列表中将自己删除 */
  let randomData = [];
  let tempData = originData;
  let index = -1;
  if (exludeData.type === 1000) {
    for (let i in tempData) {
      if (tempData[i].route === exludeData.path) {
        index = i;
        break;
      }
    }
    if (index > -1) {
      tempData.splice(index, 1);
    }
  }
  for (let i = 0; i < randomLength; i++) {
    const randomNum = getRandom(tempData.length - i)
    randomData.push(tempData[randomNum]);
    tempData.splice(randomNum, 1)
  }
  return randomData;
}

/** 生成某个范围内的随机数 */
const getRandom = numDuration => {
  return Math.floor(Math.random() * numDuration);
}

export default {
  getRandomList,
}